import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from "@headlessui/react";
import React, { Fragment } from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useAuthStore } from "../../../store/useAuthStore";
import { useGetPlatformInfo, useUpdateUserInfo } from "../../../queries/auth";
import { PlatformEnum } from "../../../shared/utils";
import { handleClickForTracking } from "../../../analytics";
import { AnalyticsConstant } from "../../../AnalyticsContant";
import { trackEvent } from "../../../utils/AmpAnalytics";
import _ from "lodash";

export function SwitchProduct() {
  const [show, setShown] = useState(false);
  const contextRef = React.useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { accessToken } = useAuthStore();
  const { data: userPlatformData } = useGetPlatformInfo(
    accessToken || "",
    accessToken !== undefined && accessToken !== ""
  );
  const { mutate: updateUserInfo } = useUpdateUserInfo();

  function getCurrentPlatformData(platform: string) {
    if(!userPlatformData) return undefined
    const currentPlatform = Array.isArray(userPlatformData)
      ? userPlatformData?.find(
          (obj: any) => obj.platform?.toLowerCase() === platform.toLowerCase()
        )
      : undefined;
    return currentPlatform?.data;
  }

  const products = [
    {
      label: "CAPTABLE",
      icon: "/media/switchProductIcons/captable.svg",
      redirectURL: process.env.REACT_APP_CAPTABLE_URL,
      bgColor: "#E6EFFF",
      platform: PlatformEnum.captable,
      analytics: AnalyticsConstant.captable_redirect_button,
    },
    {
      label: "ESOP",
      icon: "/media/switchProductIcons/esop.svg",
      redirectURL: process.env.REACT_APP_ESOP_URL,
      bgColor: "#FAF9F3",
      platform: PlatformEnum.esop,
      analytics: AnalyticsConstant.esop_redirect_button,
    },
    {
      label: "PORTFOLIO",
      icon: "/media/switchProductIcons/portfolio.svg",
      redirectURL: process.env.REACT_APP_INVESTOR_URL,
      bgColor: "#E9FBF3",
      platform: PlatformEnum.investor,
      analytics: AnalyticsConstant.investor_redirect_button,
    },
    {
      label: "TASK MANAGER",
      icon: "/media/switchProductIcons/task_manager.svg",
      className: "px-2",
      redirectURL: process.env.REACT_APP_TASKMANAGER_URL,
      bgColor: "#FEF2E7",
      platform: PlatformEnum.taskManager,
      analytics: AnalyticsConstant.taskManager_redirect_button,
    },
  ];

  const handleRedirect = (
    redirectURL: string,
    platform: string,
    analytics: string
  ) => {
    const redirectKey = `${platform}_redirect_button`;
    const exploreKey = `${platform}_explore_button`;
    const access =
      getCurrentPlatformData(platform) &&
      getCurrentPlatformData(platform)?.access;
    if (access && access === true) {
      if (redirectKey in AnalyticsConstant) {
        // handleClickForTracking(AnalyticsConstant[redirectKey]);
        trackEvent(`Navigating To ${_.capitalize(platform)}`);
      }
      sessionStorage.clear();
      updateUserInfo({ data: { lastUsedProduct: platform as PlatformEnum } });
      window.location.href = `${redirectURL}`;
    } else {
      if (exploreKey in AnalyticsConstant) {
        // handleClickForTracking(AnalyticsConstant[exploreKey]);
        trackEvent(`Viewing ${_.capitalize(platform)} Explore Page`);
      }
      navigate(`/landing/explore/${platform}`);
    }
  };

  return (
    <>
      <Popover className="relative">
        <Popover className="relative">
          <div>
            <PopoverButton
              onClick={() => setShown(!show)}
              onMouseEnter={() => {
                setShown(true);
              }}
              onMouseLeave={() => {
                setShown(false);
              }}
              className={`-ml-1.5 flex gap-2 cursor-pointer items-center focus:outline-none ${
                "/profile" !== pathname
                  ? "bg-white text-secondary"
                  : "bg-secondary text-white"
              } `}
            >
              <div
                className={`group cursor-pointer  flex items-center justify-center p-2 rounded-full focus:outline-none ${
                  show
                    ? " transition-transform duration-300 scale-105 text-primary bg-primary bg-opacity-10"
                    : ""
                } `}
              >
                {" "}
                <Icon
                  icon="icon-park-outline:application-menu"
                  className={`text-gray-600   ${show ? "text-primary" : ""}`}
                  height={20}
                />
              </div>
            </PopoverButton>
          </div>
          <Transition
            show={show}
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <PopoverPanel
              onMouseEnter={() => {
                setShown(true);
              }}
              onMouseLeave={() => {
                setShown(false);
              }}
              ref={contextRef}
              className="absolute z-10 mt-5 flex w-screen max-w-max -right-12"
            >
              <div className="w-screen max-w-xs flex-auto overflow-hidden rounded-lg bg-white text-sm leading-6 shadow-lg border-2 border-gray-200">
                <div className="grid grid-cols-2 gap-4 p-6">
                  {products.map((product) => {
                    return (
                      <div
                        className={`border rounded-lg flex flex-col items-center justify-center p-4 border-gray-100 hover:bg-[var(--hover-bg)] gap-2 ${ !userPlatformData ? 'cursor-not-allowed' : 'cursor-pointer'} ${product?.className}`}
                        onClick={() =>{
                          if(userPlatformData)
                          handleRedirect(
                            product?.redirectURL || "",
                            product.platform,
                            product.analytics
                          )}
                        }
                        style={
                          {
                            "--hover-bg": product.bgColor,
                          } as React.CSSProperties
                        }
                      >
                        <img src={product.icon} />
                        <p>{product.label}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </PopoverPanel>
          </Transition>
        </Popover>
      </Popover>
    </>
  );
}
